import React from 'react'
import Circles from '../components/Circles'
import Nav from '../components/Nav'
import about1 from '../images/about1.png'
import about2 from '../images/about2.png'
import avinash from '../images/avinash.png'
import rajiv from '../images/rajiv.png'
import mac from '../images/mac.png'
import {Link} from 'react-router-dom'
import Footer from '../components/Footer'
import Christoffer from '../images/Christoffer.jpeg'
import Mandeep from '../images/Mandeep.jpeg'
import linkedin from '../images/linkedin.png'
const AboutUs = () => {
  return (
    <div className="font-poppins">
        <Nav></Nav>
        <div className="my-10 md:py-20 px-5 md:px-40">
            <div className="relative text-center items-center gap-10">
            <Circles color="#0DCD9424" className="absolute left-0"></Circles>
            <div>
            {/* <img src={about1} className="md:h-80 h-52 mx-auto"></img> */}
            </div>
            <div className="mt-10 md:mt-0">
            <p className="text-2xl font-bold">
                About us
            </p>
            <p className="mt-10">We are innovators - a team of specialists from different aspects of business and industries on a mission to make it easy for you to hire faster, better, and cost-efficiently.</p>
            <p className="mt-5">We strongly believe that having the right people is the most important bridge to constant success and innovation! Our AI platform works as your recruiter, but unlike human beings, it offers you a hiring solution which works 24/7, without bias and without boundaries.</p>
            </div>
            </div>
        </div>
        <div className="md:my-10 py-20 px-5 md:px-40 overflow-x-clip">
        <div className="grid md:grid-cols-2 relative  ">
        <Circles color="#148EFF1F" className="absolute right-0 "></Circles>
            <img src={about2} className="md:h-80 md:order-last h-52 mx-auto"></img>
            <div>
            <p className="here text-xl md:text-2xl mt-10 font-bold">Who is SIA?</p>
            <p className="mt-10 text-sm md:text-base">SIA is a game-changing AI recruitment platform that accelerates your hiring process and slashes recruitment costs by 70%. Imagine creating perfect job descriptions in seconds, evaluating every candidate's resume, interview performance, and even voice confidence with zero human effort. Sia eliminates the tedious task of manually sifting through hundreds of applications, ensuring you don't just interview the first few candidates but the best ones. Streamline your hiring, ensure no candidate is overlooked, and secure top talent faster and more efficiently with Sia– where AI meets the future of recruitment</p>
            </div>
        </div>
        </div>
        <div className="my-10 px-5 md:py-20 md:px-40 ">
            <div>
                <p className="text-2xl font-bold">Our Founders</p>
                <div className="md:grid md:grid-cols-2 space-y-5 md:space-y-0 mt-10">
                    <div className="mx-auto relative">
                    <Circles color="#148EFF2E" className="absolute right-0 top-1/2"></Circles>
                        <div className="border-2 rounded-xl p-4 shadow-xl">
                        <img src={avinash} className="h-60"></img>
                        <div className="flex items-start justify-between mt-3">
                            <div>
                                <p className="text-xl font-bold ">Avinash Singh</p>
                                <p className="">Co-founder</p>
                            </div>
                            <a href="https://www.linkedin.com/in/avinashvictor/" target="_blank">
                            <img src={linkedin} className="h-8"></img>
                            </a>
                        </div>
                        </div>
                    </div>
                    <div className="mx-auto relative">
                    <Circles color="#148EFF2E" className="absolute right-0 top-1/2"></Circles>
                        <div className="border-2 rounded-xl p-4 shadow-xl">
                        <img src={rajiv} className="h-60"></img>
                        <div className="flex items-start justify-between mt-3">
                            <div>
                                <p className="text-xl font-bold ">Rajiv Ranjan</p>
                                <p className="">Co-founder</p>
                            </div>
                            <a href="https://www.linkedin.com/in/13rajivranjan/" target='_blank'>
                            <img src={linkedin} className="h-8"></img>
                            </a>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        {/* <div className="bg-[#0DCD940F] py-10">
            <div className="flex items-center justify-evenly">
                <div className="relative ">
                <div className={`absolute left-1/2 top-1/2 `}>
                <div className={`h-[9rem] w-[9rem] absolute rounded-full -z-20 bg-[#FE7F002E] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 opacity-[18]  `}></div>
                <div className={`bg-[#FE7F002E] absolute opacity-[10] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[12rem] w-[12rem]`}></div>
                <div className={`bg-[#FE7F002E] absolute opacity-[14] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[15rem] w-[15rem]`}></div>
                </div>
                <img src={Christoffer} className="rounded-full h-40 mt-10"></img>
                <p className="text-center text-xl font-bold mt-5">Chris</p>
                </div>
                <div className='relative'>
                <div className={`absolute left-1/2 top-1/2 `}>
                <div className={`h-[9rem] w-[9rem] absolute rounded-full -z-20 bg-[#FE7F002E] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 opacity-[18]  `}></div>
                <div className={`bg-[#FE7F002E] absolute opacity-[10] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[12rem] w-[12rem]`}></div>
                <div className={`bg-[#FE7F002E] absolute opacity-[14] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[15rem] w-[15rem]`}></div>
                </div>
                <img src={Mandeep} className="rounded-full h-40 mt-10"></img>
                <p className="text-center text-xl font-bold mt-5">Mandeep</p>
                </div>
            </div>
        </div> */}
        <div className="my-10 px-5 md:py-20 md:px-40">
                <div className="bg-[#148EFFE5] rounded-xl px-10 py-10">
                    <div className="md:grid grid-cols-2 gap-5 items-center">
                        <img src={mac}></img>
                        <div className="text-white">
                            <p className="text-2xl font-bold">The 1st AI recruitment co-pilot you will ever hire!</p>
                            <p className="text-xl my-2">Hire faster, deliver efficiency!</p>
                            <Link to="/request">
                            <button className="bg-white px-5 py-2 rounded-xl mt-5 text-[#148EFFE5]">Schedule a call</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
    </div>
  )
}

export default AboutUs